<template>
  <section id="certificate-section">
    <div class="jumbotron jumbotron-fluid bg-2 m-0 pt-5 pb-5">
      <div class="container mt-5">
        <div class="row" id="resume_cer_title">
          <div class="col-12 text-center text-white">
            <h1 class="display-4 fw-bold">Certificate</h1>
            <hr class="w-25 mx-auto border-3 opacity-75">
          </div>
        </div>
        
        <!-- Resume Section -->
        <div class="row mt-4 justify-content-center" id="resume_cer">
          <div class="col-md-12 text-center text-white">
            <h3 class="fw-semibold">Resume</h3>
          </div>
          <div class="col-md-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <h5 class="mb-3 text-dark">Resume (Thai)</h5>
              <a :href="`${publicPath}images/cer/Resume_Kittichet_TH.pdf`" target="_blank">
                <img :src="require('@/assets/images/cer/Resume_Kittichet_TH.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-md-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <h5 class="mb-3 text-dark">Resume (English)</h5>
              <a :href="`${publicPath}images/cer/Resume_Kittichet_EN.pdf`" target="_blank">
                <img :src="require('@/assets/images/cer/Resume_Kittichet_EN.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
        </div>

        <div class="col-md-12 text-center my-4">
          <hr class="border-2 border-white opacity-50">
        </div>

        <!-- University Section -->
        <div class="row" id="university_cer_title">
          <div class="col-md-12 text-center text-white mb-3">
            <h3 class="fw-semibold">University</h3>
          </div>
        </div>
        <div class="row justify-content-center" id="university_cer">
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/gradeen.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/gradeen.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/gradeth.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/gradeth.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/gradeth2.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/gradeth2.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/ceren.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/ceren.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/certh.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/certh.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center d-flex flex-column gap-3 justify-content-between h-100">
              <a :href="require('@/assets/images/cer/ceritpe.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/ceritpe.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
              <a :href="require('@/assets/images/cer/cereng.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/cereng.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
        </div>

        <div class="col-md-12 text-center my-4">
          <hr class="border-2 border-white opacity-50">
        </div>

        <!-- Other Section -->
        <div class="row" id="other_cer_title">
          <div class="col-md-12 text-center text-white mb-3">
            <h3 class="fw-semibold">Other Certificates</h3>
          </div>
        </div> 
        <div class="row justify-content-center" id="other_cer">
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/udemy_git.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/udemy_git.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/aws_page.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/aws_page.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/Python_learn.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/Python_learn.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/mern_learn.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/mern_learn.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/go_maximillion.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/go_maximillion.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 col-12 my-3 d-flex justify-content-center">
            <div class="blog-text p-3 text-center">
              <a :href="require('@/assets/images/cer/udamy_nodejs.jpg')" target="_blank">
                <img :src="require('@/assets/images/cer/udamy_nodejs.jpg')" class="img-fluid img-thumbnail img-hover">
              </a>
            </div> 
          </div>
        </div> 
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CertificatePage',
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  mounted() {
    const footer = document.querySelector(".thisfooter");
    if (footer) {
      footer.classList.remove("fixitfooter");
    }
  }
})
</script>

<style scoped>
.bg-2 {
  background: rgb(134,180,26);
  background: linear-gradient(0deg, rgba(134,180,26,1) 0%, rgba(34,193,195,1) 100%);
  min-height: 100vh;
}

.blog-text {
  min-height: auto;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  width: 100%;
  max-width: 360px;
}

.blog-text:hover {
  transform: translateY(-5px);
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.25);
}

.img-hover {
  transition: opacity 0.2s ease-in-out;
}

.img-hover:hover {
  opacity: 0.9;
}
</style>
